import React from 'react';

type Stage = 'collect' | 'review' | 'summary';

interface IntakeStepperProps {
  activeStage: Stage;
  onChange: (next: Stage) => void;
}

export const IntakeStepper: React.FC<IntakeStepperProps> = ({
  activeStage,
  onChange,
}) => {
  const stages: { key: Stage; label: string }[] = [
    { key: 'collect', label: 'Data Collection' },
    { key: 'review', label: 'Evidence Review' },
    { key: 'summary', label: 'Case Summary & Recommendation' },
  ];

  const handleClick = (key: Stage) => {
    if (key === activeStage) return;
    onChange(key);
  };

  return (
    <div className="w-full bg-white border border-gray-200 rounded-md p-1 shadow-sm">
      <nav className="grid grid-cols-3 gap-1" aria-label="Intake steps">
        {stages.map((s) => {
          const isActive = s.key === activeStage;
          return (
            <button
              key={s.key}
              type="button"
              onClick={() => handleClick(s.key)}
              tabIndex={0}
              aria-label={`Go to ${s.label} step`}
              className={
                isActive
                  ? 'w-full text-sm font-medium px-3 py-2 rounded border border-gray-300 bg-gray-50 text-gray-900'
                  : 'w-full text-sm font-medium px-3 py-2 rounded border border-transparent text-gray-700 hover:bg-gray-50'
              }
            >
              {s.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default IntakeStepper;
